import React from 'react';
import LoadingSpinner from '@carvana/loading-spinner';
import { Wrapper } from './LoadingPage.styles';

export default function LoadingPage() {
  return (
    <Wrapper data-qa="loading" data-testid="loading">
      <LoadingSpinner isLarge />
    </Wrapper>
  );
}
